const toggle = document.getElementById('menuToggle');
const drawer = document.getElementById('drawer');
const closeBtn = document.getElementById('drawerClose');
const overlay = document.getElementById('drawerOverlay');

toggle.addEventListener('click', () => {
  drawer.classList.add('active');
  document.body.classList.add('no-scroll');
});

closeBtn.addEventListener('click', () => {
  drawer.classList.remove('active');
  document.body.classList.remove('no-scroll');
});

overlay.addEventListener('click', () => {
  drawer.classList.remove('active');
  document.body.classList.remove('no-scroll');
});